import React from 'react';
import DataContainer from 'Components/UI/DataContainer';
import PropTypes from 'prop-types';
import useRelationship from 'Hooks/useRelationship';
import { useListDetailViewContext } from 'Organisms/ListDetailView/Context';
import { noop } from 'Helpers/PropTypes';
import DetailPicker from './DetailPicker';

const DetailContainer = ({ relationshipLink, setActiveTabResourceType }) => {
  const {
    listIsInitializing,
    listLoading,
    refreshListCollection,
  } = useListDetailViewContext();

  const {
    isInitializing,
    loading,
    loadingError,
    collection,
    refreshCollection: refreshDetailCollection,
  } = useRelationship(
    relationshipLink,
  );

  let refreshCollection = refreshDetailCollection;
  // if relationship has data, this means the relationship is included and the parent collection must be refreshed as a whole
  if (relationshipLink.data) {
    refreshCollection = refreshListCollection;
  }

  return (
    <DataContainer
      component={DetailPicker}
      loading={isInitializing || listIsInitializing || loading || listLoading}
      loadingError={loadingError}
      componentProps={{
        collection,
        refreshCollection,
        setActiveTabResourceType,
      }}
    />
  );
};

DetailContainer.defaultProps = {
  setActiveTabResourceType: noop,
};

DetailContainer.propTypes = {
  relationshipLink: PropTypes.object.isRequired,
  setActiveTabResourceType: PropTypes.func,
};

export default DetailContainer;
